import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { getPausenartIndicator } from '../../getPausenartIndicator';
import { TableCell } from '@/components/ui/table';
import { ArbeitszeitenPausenart } from '@/domain/arbeitszeiten/entities';

export function PausenartCell({
  pausenart,
}: {
  pausenart: ArbeitszeitenPausenart;
}) {
  return (
    <TableCell className="font-medium p-4">
      <div className="flex gap-1 items-baseline">
        <FontAwesomeIcon
          className="text-primary-blue-B400"
          icon={getPausenartIndicator(pausenart)}
        />
        <span className="hidden md:inline-block md:font-semibold">
          {t(`entities.pausenart.${pausenart}`)}
        </span>
      </div>
    </TableCell>
  );
}
